<template>
  <div>
    <div class="table_list" style="margin-bottom: 20px" v-if="item.length > 0">
      <el-table :data="item" style="width: 100%">
        <el-table-column prop="name" label="货物信息">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <div class="img">
                <img
                  :src="
                    scope.row.consumableImgUrl == '' || scope.row.consumableImgUrl == null
                      ? logo
                      : scope.row.consumableImgUrl
                  "
                  style="width: 60px; height: 60px; margin-right: 10px"
                />
              </div>
              <div>
                <div>{{ scope.row.brand }}&emsp;{{ scope.row.name }}</div>
                <div>型号：{{ scope.row.model }}</div>
                <div>{{ scope.row.remark ? "-" : scope.row.remark }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单位" min-width="50px"> </el-table-column>
        <el-table-column label="操作" min-width="50px">
          <template slot-scope="scope">
            <div @click="onQuote(scope.row)" style="color: #4991ff; cursor: pointer">
              引用
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="库存调整" prop="adjustNum">
          <el-input-number v-model="ruleForm.adjustNum"></el-input-number>
          <div style="color: rgb(25, 190, 107)">输入正数为增加库存，负数为减少库存</div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入备注"
            v-model="ruleForm.remark"
          >
          </el-input>
        </el-form-item>
        <el-form-item align="center">
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            style="margin-left: -80px"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
let customerId = window.localStorage.getItem("customerId");
import logo from "../../assets/logo.png";
export default {
  props: ["inventoryId", "createBy", "item", "quote"],
  data() {
    return {
      ruleForm: {
        adjustNum: 1,
        inventoryId: this.inventoryId,
        createBy: this.createBy,
      },
      rules: {
        adjustNum: [{ required: true, trigger: "blur", type: "number" }],
      },
      logo: logo,
      customerId: Number(customerId),
    };
  },
  created() {},
  methods: {
    submitForm(formName) {
      let q = this.ruleForm;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/inventory/log`, q, "PUT")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
              }
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 2000);
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 2000);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onQuote(row) {
      this.$emit("quote", row, this.inventoryId);
    },
    // handleSubmit() {
    //   if (!this.action) {
    //     return true;
    //   }
    //   let q = this.forms;
    //   this.$refs.form.validate((valid) => {
    //     if (valid) {
    //       this.sloading = true;
    //       $utils.api
    //         .load(`/admin/system/inventory/log`, q, "PUT")
    //         .then((res) => {
    //           this.sloading = false;
    //           if (res.status) {
    //             $utils.toast.success("保存成功");
    //           }
    //           this.$Modal.remove();
    //           setTimeout(() => {
    //             $utils.url.go(0);
    //           }, 2000);
    //         })
    //         .catch((e) => {
    //           this.sloading = false;
    //           $utils.toast.error("保存异常" + e.message);
    //           this.$Modal.remove();
    //           setTimeout(() => {
    //             $utils.url.go(0);
    //           }, 2000);
    //         });
    //     }
    //   });
    // },
  },
};
</script>
